import { HasuraOrderByInputModel } from '../models/HasuraOrderByInputModel';
import SortBy from '../models/SortBy';

const _toOrderByInput = (sortBy: SortBy): HasuraOrderByInputModel => ({
  [sortBy.field]: sortBy.sort.toUpperCase() || 'ASC',
});

export function toOrderByInput(sortBy: SortBy | undefined): HasuraOrderByInputModel | undefined;
export function toOrderByInput(sortBy: SortBy[] | undefined): HasuraOrderByInputModel[] | undefined;
export function toOrderByInput(
  sortBy: SortBy | SortBy[] | undefined,
): HasuraOrderByInputModel | HasuraOrderByInputModel[] | undefined {
  if (!sortBy) return;
  return Array.isArray(sortBy) ? sortBy.map(_toOrderByInput) : _toOrderByInput(sortBy);
}
